import { render, staticRenderFns } from "./businessDetail.vue?vue&type=template&id=bfefe2ae&scoped=true&"
import script from "./businessDetail.vue?vue&type=script&lang=js&"
export * from "./businessDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessDetail.vue?vue&type=style&index=0&id=bfefe2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefe2ae",
  null
  
)

export default component.exports